// extracted by mini-css-extract-plugin
module.exports = {"socket":"decimalPlacement_socket__sd66_","socket-in":"decimalPlacement_socket-in__G93CX"};